import { 
    DOCUMENT_EXTENSIONS,
    DOCUMENT_REQUEST_LOCATION, 
    IDocumentRequest 
} from '../../../../models/utilities/document-request';
import { API_METHODS } from '../../../../models/utilities/type-models';
import { ApiEndpoints } from '../../../../utils/app-constants';

export class MessageDocument implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab : boolean = false;
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    public url : string = '';

    constructor(id : number) {
        this.url = ApiEndpoints.COMMUNICATION_MESSAGE_DOCUMENT.formattify(id);
        this.filename = `Message_${ id }`;
    }

}
